import React from "react";
import { MobileNavBarTab } from "./mobile-nav-bar-tab";

export const MobileNavBarTabs = ({ handleClick }) => {
  return (
    <div className="mobile-nav-bar__tabs">
      {/* <MobileNavBarTab
        path="/live"
        label="live search"
        handleClick={handleClick}
      /> */}
      <MobileNavBarTab path="/" label="search" handleClick={handleClick} />
      <MobileNavBarTab path="/about" label="about" handleClick={handleClick} />
      {/* <MobileNavBarTab
        path="/favorites"
        label="favorites"
        handleClick={handleClick}
      /> */}
    </div>
  );
};
